import { render, staticRenderFns } from "./UseEle.vue?vue&type=template&id=3c6036d8&scoped=true"
import script from "./UseEle.vue?vue&type=script&lang=js"
export * from "./UseEle.vue?vue&type=script&lang=js"
import style0 from "./UseEle.vue?vue&type=style&index=0&id=3c6036d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6036d8",
  null
  
)

export default component.exports